import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllCoursesUserUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllCoursesUser
  implements GetAllCoursesUserUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllCoursesUserUseCaseInterface.Result>,
  ) {}

  async execute(
    params?: GetAllCoursesUserUseCaseInterface.Params,
  ): Promise<GetAllCoursesUserUseCaseInterface.Result> {
    let requestUrl = this.url;
    if (params.entityId) {
      requestUrl += `?entity=${params.entityId}`;
    }

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
